import React from 'react';

export default function SocialMediaIcon() {
  return (
    <svg
      className="svg-icon"
      width="48px"
      height="46px"
      viewBox="0 0 48 46"
      role="img"
      aria-labelledby="social-media-icon-title"
    >
      <title id="social-media-icon-title">Social Media Icon</title>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g fill="#19A6A8" fillRule="nonzero">
          <path
            d={
              'M17.7391304,15.1826819 L14.7014235,12.4987692 ' +
              'C15.0552383,11.897819 15.2741147,11.2174044 15.2741147,10.4833513 ' +
              'C15.2741147,8.15702872 13.2585393,6.27272727 10.7690859,6.27272727 ' +
              'C8.27963247,6.27272727 6.26086957,8.15603541 6.26086957,10.4833513 ' +
              'C6.26086957,12.8106672 8.27963247,14.695962 10.7690859,14.695962 ' +
              'C11.6467165,14.695962 12.4584717,14.4516087 13.1512261,14.0463399 ' +
              'L16.184683,16.7272727 C16.6436859,16.160095 17.1611267,15.640596 ' +
              '17.7391304,15.1826819 Z'
            }
          />
          <path
            d={
              'M30.0770821,14.6363636 L34.02582,8.26627223 ' +
              'C34.4145613,8.3728888 34.8178543,8.44961288 35.2408963,8.44961288 ' +
              'C37.6804035,8.44961288 39.6521739,6.55841415 39.6521739,4.22381002 ' +
              'C39.6521739,1.89020232 37.6804035,0 35.2408963,0 C32.8055467,0 ' +
              '30.8348157,1.8892059 30.8348157,4.22381002 C30.8348157,5.38264255 ' +
              '31.3223014,6.42987641 32.110178,7.19412795 L28.173913,13.5462839 ' +
              'C28.8505723,13.8402268 29.4887731,14.2069081 30.0770821,14.6363636 Z'
            }
          />
          <path
            d={
              'M43.8009356,20.9090909 C41.9936931,20.9090909 ' +
              '40.4628874,22.0525915 39.8693906,23.6469806 L34.6398808,23.132948 ' +
              'C34.6398808,23.1724131 34.6458257,23.2099049 34.6458257,23.2483833 ' +
              'C34.6458257,23.9271826 34.570524,24.5901959 34.4347826,25.2305168 ' +
              'L39.6623107,25.7445494 C39.97838,27.7414823 41.7053666,29.2727273 ' +
              '43.8009356,29.2727273 C46.121419,29.2727273 48,27.4020826 ' +
              '48,25.0914024 C48,22.7817088 46.121419,20.9090909 43.8009356,20.9090909 Z'
            }
          />
          <path
            d={
              'M28.3013777,37.5537005 L27.1399073,32.4090909 ' +
              'C26.4843655,32.6405784 25.8022477,32.8062117 25.090601,32.8890283 ' +
              'L26.25404,38.0346357 C24.9203177,38.7420694 24,40.1399744 ' +
              '24,41.7723602 C24,44.1091863 25.866227,46 28.176372,46 ' +
              'C30.4815954,46 32.3478261,44.1081886 32.3478261,41.7723602 ' +
              'C32.3507754,39.478439 30.5475433,37.6215503 28.3013777,37.5537005 Z'
            }
          />
          <path
            d={
              'M14.938394,25.0909091 L8.10233851,27.4560769 ' +
              'C7.31364292,26.2117042 5.95579628,25.3864207 4.41066045,25.3864207 ' +
              'C1.97277948,25.3864207 0,27.4249138 0,29.9415985 C0,32.4615069 ' +
              '1.97277948,34.5 4.41066045,34.5 C6.84646044,34.5 ' +
              '8.8244424,32.4615069 8.8244424,29.9415985 C8.8244424,29.8362889 ' +
              '8.80259199,29.739576 8.79426803,29.6364155 L15.6521739,27.2648002 ' +
              'C15.3431467,26.5759895 15.0975898,25.8506427 14.938394,25.0909091 Z'
            }
          />
          <ellipse cx="24" cy="23" rx="7.30434783" ry="7.31818182" />
        </g>
      </g>
    </svg>
  );
}
